import { render, staticRenderFns } from "./my_slide1.vue?vue&type=template&id=23036408&scoped=true&"
import script from "./my_slide1.vue?vue&type=script&lang=js&"
export * from "./my_slide1.vue?vue&type=script&lang=js&"
import style0 from "./my_slide1.vue?vue&type=style&index=0&id=23036408&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23036408",
  null
  
)

export default component.exports